export enum ApplicationToolbarControl {
  Filter = 'filter',
  Bulk = 'bulk',
  RefreshAll = 'refresh_all',
  RefreshCatalogs = 'refresh_catalogs',
  AddCatalog = 'add_catalog',
  PullImage = 'pull_image',
  Launch = 'launch',
  Catalogs = 'catalogs',
  Settings = 'settings',
}
